<div class="text-center">
    <div style="display: inline-block;" *ngFor="let theme of themes">
        <span class="badge filter" [style.background]="theme.color" [class.active]="theme.isActive" (click)=onChangeTheme(theme)></span>
    </div>
</div>